import cx from 'classnames'
import Styles from './BottomMessage.module.scss'
import { Button } from '../Button'
import { DocMode } from '../../stores/DocStore.types'
import { useDocStore } from '../../stores/DocStore'

export const DocCompleteMessage = () => {
  const docStore = useDocStore()
  const itemsLeft = docStore.cleanupModeStore.collabItemsForCleanup.length
  const finishMessage =
    itemsLeft === 1 ? 'The item has been cleaned up!' : `All ${itemsLeft} items have been cleaned up!`

  return (
    <div className={cx(Styles.messageContainer, Styles.finished)}>
      <div className={Styles.emoji}>✨</div>
      <div className={Styles.message}>
        <div>Congratulations!</div>
        <span>{itemsLeft > 0 ? <span>{finishMessage}</span> : <span>Nothing to clean up</span>}</span>
      </div>
      <Button className={Styles.leaveButton} size="md" onPress={() => docStore?.setDocMode(DocMode.Editor)}>
        Leave
      </Button>
    </div>
  )
}
